var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error_page"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"big"},[_vm._v("404")]),_vm._v(" "),_c('div',[_vm._v("你要访问的页面已经遗失在异次元空间中...")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.remainTime)+"秒后返回主界面")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("点击此处立即返回")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5377248b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/errorPage.vue
// module id = null
// module chunks = 